export default {
    "1025": {
        "symbol": "ر.س.‏",
        "position": "after"
    },
    "1052": {
        "symbol": "Lek",
        "position": "before"
    },
    "1078": {
        "symbol": "R",
        "position": "before"
    },
    "1118": {
        "symbol": "ETB",
        "position": "before"
    },
    "1156": {
        "symbol": "€",
        "position": "before"
    },
    "2049": {
        "symbol": "د.ع.‏‏",
        "position": "after"
    },
    "3073": {
        "symbol": "ج.م.‏‏",
        "position": "after"
    },
    "4097": {
        "symbol": "د.ل.‏‏",
        "position": "after"
    },
    "5121": {
        "symbol": "د.ج.‏",
        "position": "after"
    },
    "6145": {
        "symbol": "د.م.‏‏",
        "position": "after"
    },
    "7169": {
        "symbol": "د.ت.‏",
        "position": "after"
    },
    "8193": {
        "symbol": "ر.ع.‏",
        "position": "after"
    },
    "9217": {
        "symbol": "ر.ي.‏",
        "position": "after"
    },
    "10241": {
        "symbol": "ل.س.‏",
        "position": "after"
    },
    "11265": {
        "symbol": "د.ا.‏‏",
        "position": "after"
    },
    "12289": {
        "symbol": "ل.ل.‏",
        "position": "after"
    },
    "13313": {
        "symbol": "د.ك.‏‏",
        "position": "after"
    },
    "14337": {
        "symbol": "د.إ.‏",
        "position": "after"
    },
    "15361": {
        "symbol": "د.ب.‏",
        "position": "after"
    },
    "16385": {
        "symbol": "ر.ق.‏",
        "position": "after"
    },
    "1067": {
        "symbol": "դր.",
        "position": "before"
    },
    "1068": {
        "symbol": "man.",
        "position": "before"
    },
    "1069": {
        "symbol": "€‏",
        "position": "before"
    },
    "1093": {
        "symbol": "টা",
        "position": "before"
    },
    "1101": {
        "symbol": "ট",
        "position": "before"
    },
    "1133": {
        "symbol": "һ.",
        "position": "before"
    },
    "2092": {
        "symbol": "ман.",
        "position": "before"
    },
    "2117": {
        "symbol": "৳",
        "position": "before"
    },
    "5146": {
        "symbol": "KM",
        "position": "before"
    },
    "8218": {
        "symbol": "КМ",
        "position": "before"
    },
    "1026": {
        "symbol": "лв.",
        "position": "before"
    },
    "1027": {
        "symbol": "€",
        "position": "before"
    },
    "1028": {
        "symbol": "NT$",
        "position": "before"
    },
    "1029": {
        "symbol": "Kč",
        "position": "before"
    },
    "1030": {
        "symbol": "kr.",
        "position": "before"
    },
    "1031": {
        "symbol": "€",
        "position": "before"
    },
    "1032": {
        "symbol": "€",
        "position": "before"
    },
    "1033": {
        "symbol": "$",
        "position": "before"
    },
    "1035": {
        "symbol": "€",
        "position": "before"
    },
    "1036": {
        "symbol": "€",
        "position": "before"
    },
    "1037": {
        "symbol": "₪",
        "position": "before"
    },
    "1038": {
        "symbol": "Ft",
        "position": "before"
    },
    "1039": {
        "symbol": "kr.",
        "position": "before"
    },
    "1043": {
        "symbol": "€",
        "position": "before"
    },
    "1050": {
        "symbol": "kn",
        "position": "before"
    },
    "1057": {
        "symbol": "Rp",
        "position": "before"
    },
    "1059": {
        "symbol": "р.",
        "position": "before"
    },
    "1061": {
        "symbol": "kr",
        "position": "before"
    },
    "1079": {
        "symbol": "Lari",
        "position": "before"
    },
    "1080": {
        "symbol": "kr.",
        "position": "before"
    },
    "1081": {
        "symbol": "रु",
        "position": "before"
    },
    "1095": {
        "symbol": "રૂ",
        "position": "before"
    },
    "1110": {
        "symbol": "€",
        "position": "before"
    },
    "1122": {
        "symbol": "€",
        "position": "before"
    },
    "1124": {
        "symbol": "PhP",
        "position": "before"
    },
    "1125": {
        "symbol": "ރ.",
        "position": "after"
    },
    "1128": {
        "symbol": "N",
        "position": "before"
    },
    "1135": {
        "symbol": "kr.",
        "position": "before"
    },
    "1136": {
        "symbol": "N",
        "position": "before"
    },
    "1150": {
        "symbol": "€",
        "position": "before"
    },
    "1155": {
        "symbol": "€",
        "position": "before"
    },
    "1164": {
        "symbol": "؋",
        "position": "after"
    },
    "2052": {
        "symbol": "¥",
        "position": "before"
    },
    "2055": {
        "symbol": "Fr.",
        "position": "before"
    },
    "2057": {
        "symbol": "£",
        "position": "before"
    },
    "2060": {
        "symbol": "€",
        "position": "before"
    },
    "2067": {
        "symbol": "€",
        "position": "before"
    },
    "3076": {
        "symbol": "HK$",
        "position": "before"
    },
    "3079": {
        "symbol": "€",
        "position": "before"
    },
    "3081": {
        "symbol": "$",
        "position": "before"
    },
    "3084": {
        "symbol": "$",
        "position": "before"
    },
    "4100": {
        "symbol": "$",
        "position": "before"
    },
    "4103": {
        "symbol": "€",
        "position": "before"
    },
    "4105": {
        "symbol": "$",
        "position": "before"
    },
    "4108": {
        "symbol": "fr.",
        "position": "before"
    },
    "4122": {
        "symbol": "KM",
        "position": "before"
    },
    "5124": {
        "symbol": "MOP",
        "position": "before"
    },
    "5127": {
        "symbol": "CHF",
        "position": "before"
    },
    "5129": {
        "symbol": "$",
        "position": "before"
    },
    "5132": {
        "symbol": "€",
        "position": "before"
    },
    "6153": {
        "symbol": "€",
        "position": "before"
    },
    "6156": {
        "symbol": "€",
        "position": "before"
    },
    "7177": {
        "symbol": "R",
        "position": "before"
    },
    "8201": {
        "symbol": "J$",
        "position": "before"
    },
    "9225": {
        "symbol": "$",
        "position": "before"
    },
    "10249": {
        "symbol": "BZ$",
        "position": "before"
    },
    "11273": {
        "symbol": "TT$",
        "position": "before"
    },
    "12297": {
        "symbol": "Z$",
        "position": "before"
    },
    "13321": {
        "symbol": "Php",
        "position": "before"
    },
    "16393": {
        "symbol": "Rs.",
        "position": "before"
    },
    "17417": {
        "symbol": "RM",
        "position": "before"
    },
    "18441": {
        "symbol": "$",
        "position": "before"
    },
    "1034": {
        "symbol": "€",
        "position": "before"
    },
    "1040": {
        "symbol": "€",
        "position": "before"
    },
    "1041": {
        "symbol": "¥",
        "position": "before"
    },
    "1042": {
        "symbol": "₩",
        "position": "before"
    },
    "1044": {
        "symbol": "kr",
        "position": "before"
    },
    "1045": {
        "symbol": "zł",
        "position": "before"
    },
    "1046": {
        "symbol": "R$",
        "position": "before"
    },
    "1047": {
        "symbol": "fr.",
        "position": "before"
    },
    "1048": {
        "symbol": "lei",
        "position": "before"
    },
    "1049": {
        "symbol": "р.",
        "position": "before"
    },
    "1051": {
        "symbol": "€",
        "position": "before"
    },
    "1053": {
        "symbol": "kr",
        "position": "before"
    },
    "1054": {
        "symbol": "฿",
        "position": "before"
    },
    "1055": {
        "symbol": "TL",
        "position": "before"
    },
    "1056": {
        "symbol": "Rs",
        "position": "before"
    },
    "1058": {
        "symbol": "₴",
        "position": "before"
    },
    "1060": {
        "symbol": "€",
        "position": "before"
    },
    "1062": {
        "symbol": "Ls",
        "position": "before"
    },
    "1063": {
        "symbol": "Lt",
        "position": "before"
    },
    "1064": {
        "symbol": "т.р.",
        "position": "before"
    },
    "1065": {
        "symbol": "ريال",
        "position": "after"
    },
    "1066": {
        "symbol": "₫",
        "position": "before"
    },
    "1070": {
        "symbol": "€",
        "position": "before"
    },
    "1071": {
        "symbol": "ден.",
        "position": "before"
    },
    "1074": {
        "symbol": "R",
        "position": "before"
    },
    "1076": {
        "symbol": "R",
        "position": "before"
    },
    "1077": {
        "symbol": "R",
        "position": "before"
    },
    "1082": {
        "symbol": "€",
        "position": "before"
    },
    "1083": {
        "symbol": "kr",
        "position": "before"
    },
    "1086": {
        "symbol": "RM",
        "position": "before"
    },
    "1087": {
        "symbol": "Т",
        "position": "before"
    },
    "1088": {
        "symbol": "сом",
        "position": "before"
    },
    "1089": {
        "symbol": "S",
        "position": "before"
    },
    "1090": {
        "symbol": "m.",
        "position": "before"
    },
    "1091": {
        "symbol": "so'm",
        "position": "before"
    },
    "1092": {
        "symbol": "р.",
        "position": "before"
    },
    "1094": {
        "symbol": "ਰੁ",
        "position": "before"
    },
    "1096": {
        "symbol": "ଟ",
        "position": "before"
    },
    "1097": {
        "symbol": "ரூ",
        "position": "before"
    },
    "1098": {
        "symbol": "రూ",
        "position": "before"
    },
    "1099": {
        "symbol": "ರೂ",
        "position": "before"
    },
    "1100": {
        "symbol": "ക",
        "position": "before"
    },
    "1102": {
        "symbol": "रु",
        "position": "before"
    },
    "1103": {
        "symbol": "रु",
        "position": "before"
    },
    "1104": {
        "symbol": "₮",
        "position": "before"
    },
    "1105": {
        "symbol": "¥",
        "position": "before"
    },
    "1106": {
        "symbol": "£",
        "position": "before"
    },
    "1107": {
        "symbol": "៛",
        "position": "before"
    },
    "1108": {
        "symbol": "₭",
        "position": "before"
    },
    "1111": {
        "symbol": "रु",
        "position": "before"
    },
    "1114": {
        "symbol": "ل.س.‏",
        "position": "after"
    },
    "1115": {
        "symbol": "රු.",
        "position": "before"
    },
    "1117": {
        "symbol": "$",
        "position": "before"
    },
    "1121": {
        "symbol": "रु",
        "position": "before"
    },
    "1123": {
        "symbol": "؋",
        "position": "after"
    },
    "1130": {
        "symbol": "N",
        "position": "before"
    },
    "1131": {
        "symbol": "$",
        "position": "before"
    },
    "1132": {
        "symbol": "R",
        "position": "before"
    },
    "1134": {
        "symbol": "€",
        "position": "before"
    },
    "1144": {
        "symbol": "¥",
        "position": "before"
    },
    "1146": {
        "symbol": "$",
        "position": "before"
    },
    "1148": {
        "symbol": "$",
        "position": "before"
    },
    "1152": {
        "symbol": "¥",
        "position": "before"
    },
    "1153": {
        "symbol": "$",
        "position": "before"
    },
    "1154": {
        "symbol": "€",
        "position": "before"
    },
    "1157": {
        "symbol": "с.",
        "position": "before"
    },
    "1158": {
        "symbol": "Q",
        "position": "before"
    },
    "1159": {
        "symbol": "RWF",
        "position": "before"
    },
    "1160": {
        "symbol": "XOF",
        "position": "before"
    },
    "1169": {
        "symbol": "£",
        "position": "before"
    },
    "2058": {
        "symbol": "$",
        "position": "before"
    },
    "2064": {
        "symbol": "fr.",
        "position": "before"
    },
    "2068": {
        "symbol": "kr",
        "position": "before"
    },
    "2070": {
        "symbol": "€",
        "position": "before"
    },
    "2074": {
        "symbol": "Din.",
        "position": "before"
    },
    "2077": {
        "symbol": "€",
        "position": "before"
    },
    "2094": {
        "symbol": "€",
        "position": "before"
    },
    "2107": {
        "symbol": "kr",
        "position": "before"
    },
    "2108": {
        "symbol": "€",
        "position": "before"
    },
    "2110": {
        "symbol": "$",
        "position": "before"
    },
    "2115": {
        "symbol": "сўм",
        "position": "before"
    },
    "2128": {
        "symbol": "¥",
        "position": "before"
    },
    "2141": {
        "symbol": "$",
        "position": "before"
    },
    "2143": {
        "symbol": "DZD",
        "position": "before"
    },
    "2155": {
        "symbol": "$",
        "position": "before"
    },
    "3082": {
        "symbol": "€",
        "position": "before"
    },
    "3098": {
        "symbol": "Дин.",
        "position": "before"
    },
    "3131": {
        "symbol": "€",
        "position": "before"
    },
    "3179": {
        "symbol": "S/.",
        "position": "before"
    },
    "4106": {
        "symbol": "Q",
        "position": "before"
    },
    "4155": {
        "symbol": "kr",
        "position": "before"
    },
    "5130": {
        "symbol": "₡",
        "position": "before"
    },
    "5179": {
        "symbol": "kr",
        "position": "before"
    },
    "6154": {
        "symbol": "B/.",
        "position": "before"
    },
    "6170": {
        "symbol": "KM",
        "position": "before"
    },
    "6203": {
        "symbol": "kr",
        "position": "before"
    },
    "7178": {
        "symbol": "RD$",
        "position": "before"
    },
    "7194": {
        "symbol": "КМ",
        "position": "before"
    },
    "7227": {
        "symbol": "kr",
        "position": "before"
    },
    "8202": {
        "symbol": "Bs. F.",
        "position": "before"
    },
    "8251": {
        "symbol": "€",
        "position": "before"
    },
    "9226": {
        "symbol": "$",
        "position": "before"
    },
    "9242": {
        "symbol": "Din.",
        "position": "before"
    },
    "9275": {
        "symbol": "€",
        "position": "before"
    },
    "10250": {
        "symbol": "S/.",
        "position": "before"
    },
    "10266": {
        "symbol": "Дин.",
        "position": "before"
    },
    "11274": {
        "symbol": "$",
        "position": "before"
    },
    "11290": {
        "symbol": "€",
        "position": "before"
    },
    "12298": {
        "symbol": "$",
        "position": "before"
    },
    "12314": {
        "symbol": "€",
        "position": "before"
    },
    "13322": {
        "symbol": "$",
        "position": "before"
    },
    "14346": {
        "symbol": "$U",
        "position": "before"
    },
    "15370": {
        "symbol": "Gs",
        "position": "before"
    },
    "16394": {
        "symbol": "$b",
        "position": "before"
    },
    "17418": {
        "symbol": "$",
        "position": "before"
    },
    "18442": {
        "symbol": "L.",
        "position": "before"
    },
    "19466": {
        "symbol": "C$",
        "position": "before"
    },
    "20490": {
        "symbol": "$",
        "position": "before"
    },
    "21514": {
        "symbol": "$",
        "position": "before"
    }
};